import React, { useMemo } from 'react';
import { useIntl, getLocale } from 'umi';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';

import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { SortByListItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { ITableInfoListProp } from '@/pages/intelligence/pages/GenreProfile/typings';
import { METRICS_TEXT_MAP } from '../config';

export default function MetricColHeader(props) {
  const { config, sortKey, sortOrder, entityType, infoConfig, onSortChange } =
    props;
  const {
    title: propsTitle,
    source: metricSource,
    metric: metricName,
    isNeedSort,
    align,
    childWidth,
    childAlign,
    metricExplanation,
  } = config;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  // 转换翻译
  const title: string = useMemo(() => {
    return formatMessage({ id: propsTitle });
  }, [propsTitle, locale]);

  const getSortList = (): SortByListItemType[] => {
    if (!isNeedSort) return [];
    const _list = [
      {
        key: `${metricName}_0`,
        text: title,
        title,
        ratioType: 0,
      },
      {
        key: `${metricName}_1`,
        text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
        title: `${title}(%)`,
        ratioType: 1,
      },
    ];
    return _list;
  };

  const tagetMetricExplanation = useMemo(() => {
    const metricTextList =
      metricExplanation || METRICS_TEXT_MAP[`${metricSource}_${metricName}`];
    let str = '';
    metricTextList?.forEach((textKey: string) => {
      str += formatMessage({ id: textKey });
    });
    return str;
  }, [metricSource, metricName, metricExplanation, locale]);

  const getTipText = (_metricName: string) => {
    const find = infoConfig?.find(
      (item: ITableInfoListProp) => item.key === _metricName,
    );
    if (!find) return null;
    return <span>{formatMessage({ id: find.text })}</span>;
  };

  const getElContent = () => {
    return (
      <SortBy
        key={metricName}
        defaultKey={sortKey}
        defaultValue={sortOrder}
        svgIcon={getDataSourceIcon(metricSource)}
        svgTip={
          <DataSourceBubbleInfo
            dataOfDom={title}
            comesFormDom={
              <>
                <img src={getDataSourceIcon(metricSource)} />
                {DATASOURCE_NAME[metricSource]}
              </>
            }
            dataSource={metricSource}
            metricKey={metricName}
            entityType={entityType}
          />
        }
        // 指标的提示由metricExplanation决定，这个是特殊的
        // 如果metricExplanation没有，则使用source_metric查询
        content={<>{tagetMetricExplanation}</>}
        list={getSortList()}
        title={title}
        isNoDropdown={!isNeedSort}
        tipText={getTipText(metricName)}
        onChange={onSortChange}
      />
    );
  };

  return (
    <>
      {align === 'center' ? (
        <CloumsCenter
          width={childWidth}
          // style={{ marginLeft: '-40px' }}
          align={childAlign}
        >
          {getElContent()}
        </CloumsCenter>
      ) : (
        getElContent()
      )}
    </>
  );
}
